/** Lowercase, strip diacritics and German umlauts, collapse whitespace. */
export function foldText(text) {
    return text
        .toLowerCase()
        .replace(/ä/g, 'a')
        .replace(/ö/g, 'o')
        .replace(/ü/g, 'u')
        .replace(/ß/g, 'ss')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}
/** Normalize whitespace and quotes without changing case. */
export function cleanText(text) {
    return text
        .replace(/\r\n?/g, '\n')
        .replace(/[\u00a0\t]+/g, ' ')
        .replace(/[ ]{2,}/g, ' ')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
}
/** Very small HTML-to-text used when a sanitized string still contains tags. */
export function stripTags(html) {
    return cleanText(html
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/(p|div|li|h\d|tr)>/gi, '\n')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'"));
}
/** Simple similarity in [0,1] based on token overlap (Dice coefficient). */
export function tokenSimilarity(a, b) {
    const ta = new Set(foldText(a)
        .split(/[^a-z0-9]+/)
        .filter(Boolean));
    const tb = new Set(foldText(b)
        .split(/[^a-z0-9]+/)
        .filter(Boolean));
    if (ta.size === 0 && tb.size === 0)
        return 1;
    if (ta.size === 0 || tb.size === 0)
        return 0;
    let common = 0;
    for (const t of ta)
        if (tb.has(t))
            common++;
    return (2 * common) / (ta.size + tb.size);
}
//# sourceMappingURL=normalize.js.map